import useUser from '@alltrails/context/hooks/useUser';
import useExperiments from '@alltrails/experiments/hooks/useExperiments';

const EXPERIMENT_KEY = 'web-growth-rm-mweb-install-drawer-v2';

const useInstallDrawerV2PrimaryCta = () => {
  const user = useUser();
  const experiments = useExperiments();

  return !user && experiments[EXPERIMENT_KEY]?.value === 'primary_cta';
};

export default useInstallDrawerV2PrimaryCta;
